import { slotObjectToDataTestIds } from '@elliemae/ds-system';

export const DSBannerName = 'DSBanner';
export const BANNER_TYPES = {
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  DANGER: 'danger',
} as const;

export const BANNER_BODY_ID = 'ds-banner-body';

// previously this was the exported data-testid object
// the one marked as // ok are the one that works with the slots convention and works with the slotObjectToDataTestIds function
//   the rest are not compatible and needs manual handling
// export const DSBannerDatatestid = {
//   CONTAINER: 'ds-banner-container', // ok
//   CUSTOM_CONTAINER: 'ds-banner-custom-container', // ok
//   ACTION_LINK: 'ds-banner-action-link', // ok
//   CLOSE_BUTTON: 'ds-banner-close-button', // ok
//   // From here down are not compatible with the slotObjectToDataTestIds function.
//   INNER_CONTAINER: 'ds-banner',
//   ICON_CONTAINER: 'ds-banner-icon',
//   // from here they were not present but they had an asigned Slot.
//   // TITLE
//   // SUBTITLE
// };

// we are naming this with the ${component_name}_slots convention to namespace & avoid errors on duplicate exports variables in aggregators

export const DSBannerSlots = {
  CONTAINER: 'container',
  INNER_CONTAINER: 'inner-container',
  CUSTOM_CONTAINER: 'custom-container',
  TITLE: 'title',
  SUBTITLE: 'subtitle',
  ICON_CONTAINER: 'icon-container',
  ACTION_LINK: 'action-link',
  CLOSE_BUTTON: 'close-button',
  LAYOUT: 'layout',
  LIVE_REGION_PORTAL: 'live-region-portal',
} as const;

// we are naming this with the ${component_name}_data_testid convention to namespace & avoid errors on duplicate exports variables in aggregators
export const DSBannerDatatestid = {
  ...(slotObjectToDataTestIds(DSBannerName, DSBannerSlots) as Record<keyof typeof DSBannerSlots, string>),
  // handling the rest of the data-testids that are not compatible with the slotObjectToDataTestIds function manually to avoid breaking changes
  INNER_CONTAINER: 'ds-banner',
  ICON_CONTAINER: 'ds-banner-icon',
};
